var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPalbit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 141.29 42.96",
    style: {
      enableBackground: "new 0 0 141.29 42.96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#ED1C2E;}\r\n\t.st1{fill:#58595B;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M105.88,5.4c-8.7,0-15.75,7.05-15.75,15.75s7.05,15.75,15.75,15.75s15.75-7.05,15.75-15.75 S114.58,5.4,105.88,5.4z M105.88,30.91l-12.3-2.5l3.3-12.07l9-9.33l9,9.33l3.3,12.07L105.88,30.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M111.09,19.13c-1.47-1.99-1.96-4.57-1.4-6.44c-1.16-0.52-2.45-0.81-3.81-0.81c-1.36,0-2.64,0.29-3.81,0.81 c0.56,1.87,0.07,4.45-1.4,6.44c-1.12,1.51-2.6,2.56-4.04,2.98c0.28,2.77,1.75,5.17,3.92,6.68c1.07-1.15,3.06-1.92,5.34-1.92 c2.28,0,4.27,0.77,5.34,1.92c2.16-1.51,3.64-3.92,3.91-6.68C113.69,21.69,112.21,20.63,111.09,19.13z M105.88,24.01 c-1.57,0-2.84-1.27-2.84-2.84c0-1.57,1.27-2.84,2.84-2.84c1.57,0,2.84,1.27,2.84,2.84C108.72,22.74,107.45,24.01,105.88,24.01z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M17.21,23.12l-0.86,3.85l-1.73,7.85h-4.15l3.29-14.95c0.95-4.3,5.22-7.72,9.49-7.72 c4.27,0,7.06,3.42,6.11,7.72c-0.95,4.32-5.22,7.69-9.5,7.69h-3.65l3.04-3.99h1.49c2.05,0,3.98-1.66,4.43-3.69 c0.45-2.03-0.74-3.73-2.8-3.73c-2.06,0-3.99,1.7-4.44,3.73L17.21,23.12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M42.1,19.86c0.45-2.03-0.75-3.73-2.81-3.73c-2.06,0-4,1.7-4.45,3.73c-0.45,2.03,0.76,3.69,2.82,3.69h3.64 l-3.12,3.99h-1.39c-4.27,0-7.05-3.38-6.1-7.69c0.95-4.3,5.22-7.72,9.49-7.72c4.27,0,7.06,3.42,6.11,7.72l-1.69,7.69h-4.18 l0.97-4.43L42.1,19.86z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "54.71,7.41 50.31,27.43 46.18,27.43 50.58,7.41  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M57.51,20.14c-0.45,2.03,0.74,3.73,2.8,3.73c2.06,0,3.99-1.7,4.44-3.73c0.45-2.03-0.75-3.69-2.81-3.69H58.3 l3.09-3.99h1.43c4.28,0,7.07,3.37,6.12,7.69c-0.95,4.3-5.24,7.72-9.51,7.72c-4.28,0-7.04-3.42-6.09-7.72l2.8-12.73h4.15 L57.51,20.14z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "76.16,12.5 72.91,27.43 68.78,27.43 72.03,12.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M78.8,7.41h4.15l-1.11,5.03l5-0.02l-3.14,4h-2.74l-0.76,3.44c-0.45,2.03,0.75,3.69,2.81,3.69l1.38,0 l0.82,0.03l-0.87,3.96h-2.21c-4.27,0-7.03-3.38-6.08-7.69L78.8,7.41z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "72.48,11.04 75.48,7.32 77.35,7.32 76.53,11.04  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPalbit);
export default __webpack_public_path__ + "static/media/palbit.d3e63b1c3210f6e30dc249ea45991e81.svg";
export { ForwardRef as ReactComponent };